module.exports = __webpack_public_path__ + "img/8.e24a1c10.jpg";